import React, { useState, useRef, useEffect } from 'react';

export const ClickableUrlInput = ({
                               value: controlledValue,
                               onChange,
                               placeholder = "Enter text with URLs...",
                               className = "",
                               ...props
                           }) => {
    const [internalValue, setInternalValue] = useState(controlledValue || '');
    const [isEditing, setIsEditing] = useState(true);
    const inputRef = useRef(null);

    // Use controlled value if provided, otherwise use internal state
    const currentValue = controlledValue !== undefined ? controlledValue : internalValue;

    // URL detection regex - matches http/https URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        if (controlledValue !== undefined && onChange) {
            onChange(e);
        } else {
            setInternalValue(newValue);
        }
    };

    const handleInputFocus = () => {
        setIsEditing(true);
    };

    const handleInputBlur = () => {
        setIsEditing(false);
    };

    const handleDisplayClick = () => {
        setIsEditing(true);
    };

    const isUrl = word => {
        const urlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
        return word.match(urlPattern)
    }

    // Focus input when switching to edit mode
    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isEditing]);

    const renderValueWithClickableUrls = (text) => {
        if (!text) return null;

        const parts = text.split(urlRegex);

        return parts.map((part, index) => {
            if (isUrl(part)) {
                return (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        // className="text-blue-600 hover:text-blue-800 underline"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {part}
                    </a>
                );
            }
            return <span key={index}>{part}</span>;
        });
    };

    const hasUrls = urlRegex.test(currentValue);

    return (
        <div
            // className="relative"
        >
            {isEditing || !hasUrls ? (
                <input
                    ref={inputRef}
                    type="text"
                    value={currentValue}
                    onChange={handleInputChange}
                    onFocus={handleInputFocus}
                    onBlur={handleInputBlur}
                    placeholder={placeholder}
                    // className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className}`}
                    {...props}
                />
            ) : (
                <div
                    onClick={handleDisplayClick}
                    // className={`w-full px-3 py-2 border border-gray-300 rounded-md bg-white cursor-text min-h-[2.5rem] flex items-center ${className}`}
                >
                    <div
                        // className="flex-1 break-all"
                    >
                        {renderValueWithClickableUrls(currentValue)}
                    </div>
                </div>
            )}
        </div>
    );
};